// src/utils/userId.js
export function getOrCreateUserId() {
  const KEY = 'app_user_id';
  let id = localStorage.getItem(KEY);
  if (!id) {
    id = (crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`);
    localStorage.setItem(KEY, id);
  }
  return id;
}
